<template>
  <div>
    <v-card>
      <v-toolbar color="primary" dark>
        <v-toolbar-title aling="center">Maestro de Reportes</v-toolbar-title>
      </v-toolbar>
      <v-card flat>
        <v-card>
          <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="4">
                <v-text-field v-model="fecinicio" label="Fecha Inicio" readonly required outlined @click="fechas('inicio')" ></v-text-field>
              </v-col>
              <v-col cols="4">
                <v-text-field v-model="fecfin" label="Fecha Inicio" readonly required outlined @click="fechas('fin')" ></v-text-field>
              </v-col>
              <v-col cols="4">
                <v-btn text color="primary" @click="consultar()">Consultar</v-btn>
              </v-col>
            </v-row>
          </v-container>
          </v-card-text>

        </v-card>
                <v-card>
                    <v-card-text>
                    <v-text-field
                        v-model="search"
                        append-icon="mdi-magnify"
                        label="Buscar"
                        single-line
                        hide-details
                    ></v-text-field>
                    <v-data-table
                        :headers="headers"
                        :items="datos"
                        :items-per-page="5"
                        class="elevation-1"
                        :search="search"
                    >
                      <template v-slot:item.gps="{ item }">
                        <a v-if="item.lat" :href="`https://maps.google.com/?q=${item.lat},${item.lng}`" target="_blank">
                          Ver
                        </a>
                        <span v-else>NO</span>
                      </template>
                    </v-data-table>
                    </v-card-text>
                    <v-card-actions>
                    <v-btn dark color="blue" @click="exportExcel(datosExcel)" v-if="datos.length>0">
                        <v-icon>mdi-file-excel-box</v-icon>
                        Exportar Excel</v-btn>
                    </v-card-actions>
                </v-card>
      </v-card>
    </v-card>
          <v-dialog v-model="calendario" persistent width="290px">
        <v-date-picker v-model="date" scrollable @input="fechasave(dialogofType)">
          <v-spacer></v-spacer>
          <v-btn text color="primary" @click="calendario = false">Cancel</v-btn>
          
        </v-date-picker>
      </v-dialog>  
  </div>
</template>
<script>
import axios from "axios";
import api from "../conf/ruta-base";
import store from "../store";
import router from '../router';
import XLSX from 'xlsx';
export default {
    name: 'Reportes',
    data() {
        return {
            apiPath: "tracer",
            search: "",
            dialog: false,
            headers: [
            { text: "Fecha", sortable: true, value: "fecha" },
            { text: "Hora", sortable: true, value: "hora" },
            { text: "Instalación", sortable: true, value: "organizacion.nombre" },
            { text: "Area", sortable: true, value: "area.nombre" },
            { text: "Usuario", align: "start", sortable: true, value: "user.nombre" },
            { text: "Ubicacion", value: "gps" },
            ], calendario: false, fecinicio: '', fecfin: '', dialogofType: null,
            datos: [], datawork: [], dataworkAnt: [], datosImport: [], datosExcel: [],
            selec: '', date: new Date().toISOString().substr(0, 10),
            editedIndex: -1,
            editedItem: {},
            defaultItem: {
                id: '', nombre: '', descripcion: '', peso: '', casoexito: '', resultados: '',
            }
        }
    },
    created() {
        this.editedItem = Object.assign({}, this.defaultItem);
    },
    mounted() {
      this.fecinicio = this.date;
      this.fecfin = this.date;
    },
    methods: {
        toast(color, text) {
            var toast = { color, text }
            store.commit("TOAST", toast)
        },
        
        exportExcel(datosXLS) {
        let data = XLSX.utils.json_to_sheet(datosXLS)
        const workbook = XLSX.utils.book_new()
        const filename = 'reporte-fullclean'
        XLSX.utils.book_append_sheet(workbook, data, filename)
        XLSX.writeFile(workbook, `${filename}.xlsx`)
      },

    fechasave(evento){
        if(evento=='inicio'){
          this.fecinicio = this.date          
        }else if(evento=='fin'){
          this.fecfin = this.date
        }
        this.dialogofType = ''
        this.calendario = false
        this.date = new Date().toISOString().substr(0, 10)
    },

      fechas(evento){
        this.dialogofType = evento;
        this.calendario = true;
      },

      consultar(){
        this.datos=[];
        this.datosExcel=[];
        axios
        .get(api.api + this.apiPath + `/rango/${this.fecinicio}/${this.fecfin}`)
        .then(r => {
          r.data.forEach(reg => {
            let hora = reg.fecha.split('T')[1].split('.')[0].split(':')
            reg.hora = hora[0] + ':' + hora[1]
            reg.fecha = reg.fecha.split('T')[0]
            let excel = {
              Fecha: reg.fecha,
              Hora: reg.hora,
              Instalacion: reg.organizacion.nombre,
              Area: reg.area.nombre,
              Usuario: reg.user.nombre,
              Latitud: reg.lat,
              Longitud: reg.lng,
            }
            this.datosExcel.push(excel)
            this.datos.push(reg)
          });
        })
        .catch(error => {
          console.log(error);
        });
      }

    },

}
</script>